var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrap",attrs:{"id":"app"}},[_c('Navbar'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('main',{staticClass:"col-12 ms-sm-auto px-md-4 test"},[_c('router-view')],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }